import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { Tab } from '@mui/material';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import { useContext, useEffect, useState } from 'react';
import CommentTickets from './components/CommentTicket';
import LineEvents from './components/LineEventsComponent';
import OffersWidget from './components/OffersWidget';

import { SessionContext } from '_models/context/app';
import DebtTickets from './components/DebtTickets';

const TabsTicket = (props) => {
  const { directNumber, ticketId, billingCycleInfo } = props;

  const [value, setValue] = useState('1');

  const sessionContext = useContext(SessionContext);
  const { setTypeServiceSelect } = sessionContext || {};

  useEffect(() => {
    setTypeServiceSelect('data');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons='auto'
            allowScrollButtonsMobile
            textColor='secondary'
            indicatorColor='secondary'
            aria-label='action tabs'
            sx={{
              '& button:hover': {
                background: '#FBF9FF',
              },
              '& button.Mui-selected': {
                color: '#673ab7',
                fontWeight: 600,
              },
            }}
            TabIndicatorProps={{
              style: {
                backgroundColor: '#673ab7',
              },
            }}
          >
            <Tab label='Eventos del ticket' value='1' />
            <Tab label='Eventos de la línea' value='2' />
            <Tab label='Ofertas' value='3' />
            {billingCycleInfo?.has_billing_cycle === true && <Tab label='Adeudos' value='4' />}
          </Tabs>
        </Box>
        <TabPanel value='1' className='tab-panel'>
          <CommentTickets directNumber={directNumber} ticketId={ticketId} />
        </TabPanel>
        <TabPanel value='2' className='tab-panel'>
          <LineEvents />
        </TabPanel>
        <TabPanel value='3' className='tab-panel'>
          <OffersWidget directNumber={directNumber} ticketId={ticketId} />
        </TabPanel>
        {billingCycleInfo?.has_billing_cycle === true && (
          <TabPanel value='4' className='tab-panel'>
            <DebtTickets billingCycleInfo={billingCycleInfo} />
          </TabPanel>
        )}
      </TabContext>
    </Box>
  );
};

export default TabsTicket;
